import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeEvery } from "redux-saga/effects"
import * as actions from "./codesByCategory.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getCodesByCategoryFlow(action: actions.GetCodesByCategoryAction): SagaIterator {
  try {
    const { category, disabled } = action.payload
    const response = yield call(api.getCodesByCategory, { category, disabled })
    yield put(actions.getCodesByCategorySuccess(response && response.data, category))
  } catch (e) {
    yield put(actions.getCodesByCategoryFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* codeByCategorySaga(): SagaIterator {
  yield takeEvery(actions.Types.GET_BY_CATEGORY, getCodesByCategoryFlow)
}
